import React from "react";
import cartBorder from "@assets/images/cartBorder.webp";
import summaryBorder from "@assets/images/cartsummaryBorder.webp";
import contactBorder from "@assets/images/borders/contactBorder.webp";
import CheckoutItemSkeleton from "./CheckoutItemSkeleton";

const CheckoutDetailsSkeleton: React.FC = () => {
  const skeletonIds = ["sk1", "sk2", "sk3"];

  return (
    <>
      <div className="flex items-start justify-around mb-12">
        <div className="relative inline-flex flex-col gap-3 z-[1] w-full items-center after:absolute after:top-5 max-sm:after:top-[14px] after:left-1/2 after:z-[-1] after:content-[''] after:w-full after:border-b after:border-primary after:border-4 after:inline-block">
          <div className="flex items-center flex-col gap-1">
            <div className="w-11 h-11 max-sm:w-8 max-sm:h-8 grid place-items-center text-2xl border-blue border-0 rounded-full bg-radial-gradient-light">
              <i className="ri-check-line text-blue text-3xl max-sm:text-xl font-bold leading-tight"></i>
            </div>
            <span className="text-primary text-xl max-sm:text-sm">
              <span>Shopping</span> cart
            </span>
          </div>
        </div>
        <div className="relative inline-flex flex-col gap-3 z-[1] w-full items-center after:absolute after:top-5 max-sm:after:top-[14px] after:left-1/2 after:z-[-1] after:content-[''] after:w-full after:border-b after:border-[#9CA3AF70] after:border-4 after:inline-block">
          <div className="flex flex-col items-center gap-1">
            <div className="w-11 h-11 max-sm:w-8 max-sm:h-8 text-[#3E474A] grid place-items-center text-2xl rounded-full bg-radial-gradient-light"></div>
            <span className="text-primary text-xl max-sm:text-sm">
              Checkout
            </span>
          </div>
        </div>
        <div className="relative inline-flex flex-col gap-3 z-[1] w-full">
          <div className="flex flex-col items-center gap-1">
            <div className="w-11 h-11 max-sm:w-8 max-sm:h-8 text-[#3E474A] grid place-items-center text-2xl rounded-full bg-blue border-2 border-primary"></div>
            <span className="text-[#B1B5C3] text-xl max-sm:text-sm">
              <span className="hidden">Order</span> confirmed
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-3 gap-10 max-md:gap-6 items-baseline max-lg:grid-cols-1 max-lg:flex max-lg:flex-col">
        <div className="col-span-2 max-lg:col-auto flex flex-col gap-8 max-sm:gap-6 w-full">
          <div className="relative pt-8 pb-14 px-14 max-xl:p-6 max-md:p-0">
            <img
              className="absolute top-0 left-0 size-full max-md:hidden"
              src={contactBorder}
              alt=""
            />
            <div className="relative">
              <h2
                className="text-primary text-2xl max-md:text-xl mb-5 max-sm:mb-3"
                id="contact-information"
              >
                Contact information
              </h2>
              <div className="grid grid-cols-2 gap-7 max-md:grid-cols-1 max-md:gap-2 contact-info-input">
                <div>
                  <label
                    className="text-secondary text-base mb-2 block f-family-mochiy-pop"
                    htmlFor="firstName"
                  >
                    First Name *
                  </label>
                  <div className="relative">
                    <div
                      id="firstName"
                      className="relative skeleton h-14 text-black p-5 z-[4] text-base f-family-mochiy-pop w-full bg-transparent focus:outline-none focus:ring-1 focus:ring-transparent focus:border-transparent"
                    ></div>
                  </div>
                </div>
                <div>
                  <label
                    className="text-secondary text-base mb-2 block f-family-mochiy-pop"
                    htmlFor="lastName"
                  >
                    Last Name *
                  </label>
                  <div className="relative">
                    <div
                      id="firstName"
                      className="relative skeleton h-14 text-black p-5 z-[4] text-base f-family-mochiy-pop w-full bg-transparent focus:outline-none focus:ring-1 focus:ring-transparent focus:border-transparent"
                    ></div>
                  </div>
                </div>
                <div>
                  <label
                    className="text-secondary text-base max-md:text-sm mb-2 block f-family-mochiy-pop"
                    htmlFor="phoneNumber"
                  >
                    Phone Number *
                  </label>
                  <div className="country-code-selector relative z-[10]">
                    <div
                      id="firstName"
                      className="relative skeleton h-14 text-black p-5 z-[4] text-base f-family-mochiy-pop w-full bg-transparent focus:outline-none focus:ring-1 focus:ring-transparent focus:border-transparent"
                    ></div>
                  </div>
                </div>
                <div>
                  <label
                    className="text-secondary text-base mb-2 block f-family-mochiy-pop"
                    htmlFor="checkoutemail"
                  >
                    Email*
                  </label>
                  <div className="relative">
                    <div
                      id="firstName"
                      className="relative skeleton h-14 text-black p-5 z-[4] text-base f-family-mochiy-pop w-full bg-transparent focus:outline-none focus:ring-1 focus:ring-transparent focus:border-transparent"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="relative pt-8 pb-14 px-14 max-xl:p-10 max-md:p-0"
            id="payment-method-section"
          >
            <img
              className="absolute top-0 left-0 size-full max-md:hidden"
              src={contactBorder}
              alt="border-image"
            />
            <div className="relative">
              <div className="flex items-center justify-between flex-wrap mb-6 max-md:items-start max-sm:mb-4 mr-4 max-md:mr-0">
                <h2 className="text-primary text-2xl max-sm:text-xl">
                  Payment Method
                </h2>

                <button
                  className="text-[#89D9EE] text-2xl duration-150 hover:scale-95 max-md:text-lg disabled:opacity-70"
                  aria-label="Add payment method"
                  type="button"
                >
                  <i className="ri-edit-line"></i> Add Payment Method
                </button>
              </div>
              <div className="grid grid-cols-3 max-sm:grid-cols-1 gap-7 max-sm:gap-2 mb-2">
                <div className="col-span-3 max-sm:col-auto">
                  <label
                    className="text-secondary text-base mb-2 block f-family-mochiy-pop"
                    htmlFor="cardNum"
                  >
                    Select from saved cards
                  </label>
                  <div className="relative max-h-[400px] overflow-auto">
                    <div className="peer custom-radio-primary skeleton w-full h-14 my-2"></div>
                    <div className="peer custom-radio-primary skeleton w-full h-14 my-2"></div>
                    <div className="peer custom-radio-primary skeleton w-full h-14 my-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center flex flex-col items-center gap-5 max-lg:hidden">
            <button className="skeleton h-16 w-full"></button>
            <div className="skeleton h-10 w-40"></div>
          </div>
        </div>

        <div className="relative pt-8 pb-20 px-12 max-lg:w-full max-md:p-0">
          <img
            className="absolute top-0 left-0 size-full max-md:hidden"
            src={cartBorder}
            alt=""
          />
          <div className="relative">
            <h5 className="text-primary text-2xl max-md:text-xl mb-5 max-md:mb-4">
              Order Summary
            </h5>
            <div className="max-h-[350px] overflow-auto max-sm:max-h-max">
              <CheckoutItemSkeleton />
            </div>
            <div className="flex flex-col gap-4 my-8 max-md:my-6">
              <div className="bg-primary p-5 max-md:p-4 w-full flex items-center justify-between skeleton !rounded-[10px_25px] gap-3">
                <div className="text-blue w-full flex items-center gap-1">
                  <i className="ri-coupon-line text-lg"></i>
                  <div className="w-full skeleton text-base font-light font-mikado-medium bg-transparent placeholder-blue outline-none disabled:opacity-50">
                    Coupon Code
                  </div>
                </div>
                <button
                  className="flex skeleton text-base text-blue duration-150 hover:scale-95 disabled:opacity-50 disabled:scale-100"
                  aria-label="Apply"
                >
                  Apply
                </button>
              </div>
            </div>
            <div className="flex flex-col gap-5 max-md:gap-4 mb-10 max-md:mb-6 max-h-[300px] max-sm:max-h-max overflow-auto">
              {skeletonIds.map((id) => {
                return (
                  <div
                    key={id}
                    className="flex items-center justify-between relative py-4 px-6 skeleton h-14"
                  ></div>
                );
              })}
            </div>
            <div className="flex flex-col gap-4 max-md:gap-3 mb-6 max-md:mb-4">
              <div className="flex items-center justify-between">
                <h6 className="text-primary text-xl max-md:text-lg">
                  Subtotal
                </h6>
                <span className="skeleton w-24 h-6"></span>
              </div>
              <div className="flex items-center justify-between">
                <h6 className="text-primary text-xl max-md:text-lg">
                  Discount
                </h6>
                <span className="skeleton w-24 h-6"></span>
              </div>

              <div className="flex items-center justify-between">
                <h6 className="text-primary text-xl max-md:text-lg">
                  shipping
                </h6>
                <span className="skeleton w-24 h-6"></span>
              </div>

              <div className="flex items-center justify-between">
                <h6 className="text-primary text-xl max-md:text-lg">
                  Tax {" (10%)"}
                </h6>
                <span className="skeleton w-24 h-6"></span>
              </div>
            </div>
            <img className="w-full" src={summaryBorder} alt="" />
            <div className="flex items-center justify-between mt-5 max-md:mt-3">
              <h6 className="text-primary text-xl max-md:text-lg">Total</h6>
              <span className="skeleton w-24 h-6"></span>
            </div>
          </div>
        </div>

        <div className="text-center hidden items-center gap-5 max-sm:gap-1 max-lg:flex w-full flex-col">
          <button className="text-3xl max-md:text-2xl max-sm:text-xl w-full rounded-[5px_60px_32px_60px] max-md:rounded-[5px_28px_16px_30px] skeleton h-16"></button>
          <div className="skeleton w-32 h-7 mt-3"></div>
        </div>
      </div>
    </>
  );
};

export default CheckoutDetailsSkeleton;
